import { get, handleError } from '@/lib/http-adapter';

export type TermsScope =
  | 'STUDIO'
  | 'CLASS'
  | 'CLASS_PACK'
  | 'SUBSCRIPTION'
  | 'TOPUP'
  | 'GIFT_CARD';

export interface ResolvedTerms {
  terms_document_id: string;
  title: string;
  content: string;
  checkout_acknowledgment: string | null;
  version: number;
  published_at: string;
  source: 'ENTITY' | 'FAMILY' | 'STUDIO';
}

export interface AcceptedTerms {
  terms_document_id: string;
  version: number;
}

export interface TermsAcceptanceStatus {
  terms_document_id: string;
  last_accepted_version: number | null;
}

export const getResolvedTerms = async (params: {
  type: TermsScope;
  // Omit for STUDIO — the backend rejects entity ids on studio scope.
  entity_ids?: string;
}): Promise<ResolvedTerms[] | undefined> => {
  try {
    const response = await get<{ resolved_terms_list: ResolvedTerms[] }>(
      '/public/terms/resolve',
      { params }
    );
    return response?.resolved_terms_list ?? [];
  } catch (error) {
    handleError(error);
  }
};

export const getTermsAcceptanceStatus = async (params: {
  terms_document_id: string;
}): Promise<TermsAcceptanceStatus | undefined> => {
  try {
    const response = await get<{ acceptance_status: TermsAcceptanceStatus }>(
      '/public/terms/acceptance-status',
      { params }
    );
    return response?.acceptance_status;
  } catch (error) {
    handleError(error);
  }
};
